"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _propTypes = require("prop-types");
var _actions = require("../../../actions");
var _style = require("./style");
var _atoms = require("../../atoms");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function GenericErrorModal(_ref) {
  var closeModalAction = _ref.closeModalAction,
    theme = _ref.theme;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ModalView, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ModalIcon, {
      size: 34,
      color: theme.colors.gray
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ModalTitle, {
      children: "N\xE3o foi poss\xEDvel enviar a sua imagem"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ModalButton, {
      onClick: closeModalAction,
      size: "medium",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_atoms.Text, {
        color: "white",
        children: "Ok! Entendi"
      })
    })]
  });
}
GenericErrorModal.propTypes = {
  closeModalAction: _propTypes.func.isRequired,
  theme: _propTypes.object.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    closeModalAction: _actions.closeModal
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(null, mapDispatchToProps)((0, _styledComponents.withTheme)(GenericErrorModal));